const footerCols = [
  {
    title: "快速榜单",
    links: ["实时热榜", "今日瓜榜", "本周吃瓜王争霸", "年度瓜王盘点"],
  },
  {
    title: "六大分区",
    links: ["综艺瓜田", "饭圈日常", "明星八卦", "社会热点"],
  },
  {
    title: "关于我们",
    links: ["榜单机制", "数据来源", "加入吃瓜群", "联系方式"],
  },
];

export default function Footer() {
  return (
    <footer className="mt-14 bg-background-200/60">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.3fr_repeat(3,0.8fr)] md:gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="fa-solid fa-crown text-sm"></i>
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">吃瓜王</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
              每天一份吃瓜王排行榜，把娱乐与社会热点聊得明明白白。看榜、追更、投票，
              和全网一起锁定话题焦点。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-tiktok-fill", "ri-douban-line"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="社交媒体入口"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:bg-background-50 hover:text-primary-600"
                >
                  <i className={`${ic} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerCols.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground-900">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a href="#top" className="text-sm text-foreground-500 transition-colors hover:text-foreground-900">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-background-300/70 pt-6">
          <p className="text-xs leading-5 text-foreground-500">
            榜单与内容由公开网络讨论自动聚合生成，话题相关描述仅为热度展示，不对任何真实人物或机构作事实性评判。
            如内容涉及侵权或失实，欢迎联系我们删除。仅供娱乐，请理性吃瓜。
          </p>
        </div>

        <div className="mt-5 flex flex-col items-start justify-between gap-3 border-t border-background-300/70 pt-5 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">© 2026 吃瓜王 · 保留所有权利</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <a href="#top" className="text-xs text-foreground-500 hover:text-foreground-900">服务协议</a>
            <a href="#top" className="text-xs text-foreground-500 hover:text-foreground-900">隐私政策</a>
            <a href="#top" className="text-xs text-foreground-500 hover:text-foreground-900">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}